import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cyclops-counter',
  templateUrl: './cyclops-counter.component.html',
  styleUrls: ['./cyclops-counter.component.scss']
})
export class cyclopsCounterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  counter = [
    {
      count:'1510',
      img:'assets/images/cyclops/counter/happy-icon.png',
      type:'Satisfied Customers'
    },
    {
      count:'1510',
      img:'assets/images/cyclops/counter/project-icon.png',
      type:'Projects Completed'
    },
    {
      count:'1510',
      img:'assets/images/cyclops/counter/work-icon.png',
      type:'Hours Worked'
    },
    {
      count:'1510',
      img:'assets/images/cyclops/counter/award-icon.png',
      type:'Awwards Winning'
    }]

}
